import { ArrowRight, BadgeCheck, Phone } from "lucide-react";

export default function Hero({ phone }) {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-[88vh] flex items-center">
      <img
        src="/assets/hero.jpg"
        alt="Front-yard flower bed and landscaping installed by Somoza's Landscaping"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-black/55" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <div className="max-w-2xl">
          <span
            data-testid="hero-free-estimate-badge"
            className="inline-flex items-center gap-2 bg-brand text-white text-xs sm:text-sm font-bold uppercase tracking-widest rounded-full px-4 py-2"
          >
            <BadgeCheck className="w-4 h-4" aria-hidden="true" />
            Free On-Site Estimates
          </span>
          <h1 className="mt-6 font-heading font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight">
            Professional Landscaping, Lawn Care &amp; Tree Services
          </h1>
          <p className="mt-5 text-white/90 text-lg leading-relaxed max-w-xl">
            Quality Landscaping Solutions for Residential and Commercial Properties.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="#estimate"
              data-testid="hero-get-estimate-button"
              className="inline-flex items-center justify-center gap-2 bg-brand text-white font-semibold rounded-full px-8 py-4 hover:bg-brand-hover transition-colors duration-200 shadow-md text-base"
            >
              Get a Free Estimate
              <ArrowRight className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="#gallery"
              data-testid="hero-view-work-button"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border-2 border-white text-white font-semibold rounded-full px-8 py-4 hover:bg-white hover:text-ink transition-colors duration-200 text-base"
            >
              View Our Work
            </a>
          </div>
          <a
            href={`tel:${(phone || "214-576-8224").replace(/[^0-9+]/g, "")}`}
            data-testid="hero-call-link"
            className="mt-6 inline-flex items-center gap-2 text-white/90 hover:text-white transition-colors text-sm font-medium"
          >
            <Phone className="w-4 h-4" aria-hidden="true" />
            Or call us now: {phone || "214-576-8224"}
          </a>
        </div>
      </div>
    </section>
  );
}
